<template>
  <teleport to="#wishlist-modals">
    <FlashMessage
      :type="flashMessage.type ?? 'success'"
      layout="inline"
      :is-open="!!flashMessage.message"
      @close="flashMessage = {}"
    >
      {{ flashMessage.message }}
    </FlashMessage>

    <SignUpModal
      v-if="signUpModal"
      title="Sign up to save this space"
      :tracking-params="{ context: 'add_to_wishlist', auth_method: 'email_password', country }"
      :api-config="apiConfig"
      :google-api-config="googleApiConfig"
      :email="email"

      @register="onSignUpModalRegister"
      @error="onSignUpModalError"
      @close="onSignUpModalClose"
      @trackEvent="onSignUpModalTrackEvent"
      @loginClick="onSignUpModalLoginClick"
    />

    <WelcomeBackLoginModal
      v-if="welcomeBackLoginModal"
      :forgot-password-url="forgotPasswordUrl"
      :sign-up="true"
      :tracking-params="{ context: 'add_to_wishlist', auth_method: 'logged_in', country }"
      :api-config="apiConfig"
      :google-api-config="googleApiConfig"
      :email="email"
      top-text="Please log in to save this space."
      @login="onWelcomeBackLoginModalLogin"
      @error="onWelcomeBackLoginModalError"
      @close="onWelcomeBackLoginModalClose"
      @trackEvent="onWelcomeBackLoginModalTrackEvent"
      @signUpClick="onWelcomeBackLoginModalSignUpClick"
    />
  </teleport>
</template>

<script>
import FlashMessage from '@/components/Ui/FlashMessage.vue';
import SignUpModal from '@/modules/user-cabinet/user-cabinet/BookingForm/SignUpModal.vue';
import WelcomeBackLoginModal from '@/modules/user-cabinet/user-cabinet/BookingForm/WelcomeBackLoginModal.vue';
import { WISHLIST_LOCAL_STORAGE_KEY } from '@/services/wishlist';

export default {
  name: 'WishlistModals',
  components: { FlashMessage, SignUpModal, WelcomeBackLoginModal },
  props: {},
  data() {
    return {
      flashMessage: {},
      roomId: null,
      signUpModal: false,
      welcomeBackLoginModal: false,
      email: '',
    };
  },
  computed: {
    forgotPasswordUrl() {
      return window._VUE_WISHLIST_MODAL.forgotPassword;
    },
    apiConfig() {
      return window._VUE_WISHLIST_MODAL.apiConfig;
    },
    googleApiConfig() {
      return window._VUE_WISHLIST_MODAL.googleApiConfig;
    },
    country() {
      return window._VUE_WISHLIST_MODAL.country;
    },
  },
  methods: {
    setFlashMessage(type, message) {
      this.flashMessage = { type, message };
    },

    onSignUpModalLoginClick(email) {
      this.onSignUpModalClose();
      this.email = email;
      this.$nextTick(() => {
        this.welcomeBackLoginModal = true;
      });
    },
    onSignUpModalClose() {
      this.signUpModal = false;
    },
    onSignUpModalTrackEvent() {

    },
    onSignUpModalError(error) {
      this.setFlashMessage('error', error);
    },
    onSignUpModalRegister() {
      this.refreshWithParam();
    },

    onWelcomeBackLoginModalLogin() {
      this.refreshWithParam();
    },
    onWelcomeBackLoginModalClose() {
      this.welcomeBackLoginModal = false;
    },
    onWelcomeBackLoginModalTrackEvent() {

    },
    onWelcomeBackLoginModalSignUpClick(email) {
      this.onWelcomeBackLoginModalClose();
      this.email = email;
      this.$nextTick(() => {
        this.signUpModal = true;
      });
    },
    onWelcomeBackLoginModalError(error) {
      this.setFlashMessage('error', error);
    },
    refreshWithParam() {
      window.sessionStorage.setItem(WISHLIST_LOCAL_STORAGE_KEY, this.roomId);
      window.location.reload();
    },
    showMessageAboutSuccessfulAddingToWishlist() {
      this.setFlashMessage('success', 'Saved in your favourites list');
      window.sessionStorage.removeItem(WISHLIST_LOCAL_STORAGE_KEY);
    },
    showMessageAboutSuccessfulRemovingToWishlist() {
      this.setFlashMessage('success', 'Removed from your favourites list');
    },
  },
  mounted() {
    window.triggerWishlistModal = (roomId) => {
      if (document.cookie.includes('tgv_returning_client=')) {
        this.welcomeBackLoginModal = true;
      } else {
        this.signUpModal = true;
      }
      this.roomId = roomId;
    };
    window.showMessageAboutSuccessfulAddingToWishlist = this.showMessageAboutSuccessfulAddingToWishlist;
    window.showMessageAboutSuccessfulRemovingToWishlist = this.showMessageAboutSuccessfulRemovingToWishlist;
  },
};
</script>
